import { createAction, props } from "@ngrx/store";

export const loadUsersDetails = createAction("[User Details] Load Users Details");
export const loadUsersDetailsSuccess = createAction("[User List] Load Users Details Success", props<{userDetails}>());
export const loadUsersDetailsError = createAction("[User List] Load Users Details Error");